import React from "react";

export default function Logo({ size = 28, withText = true, className = "", textClass = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        {/* brutalist frame */}
        <rect x="1.5" y="1.5" width="29" height="29" stroke="currentColor" strokeWidth="2.5" />
        {/* blocky "P" */}
        <path d="M11 26 V6 H21 V15 H11" stroke="currentColor" strokeWidth="3"
          strokeLinejoin="miter" strokeLinecap="butt" fill="none" />
        {/* threaded "wire" stitch (the patch) */}
        <path d="M11 10.5 L18 12.5 L11 14.5 L18 16.5" stroke="hsl(var(--primary))" strokeWidth="2.2"
          strokeLinejoin="bevel" strokeLinecap="round" fill="none" />
        {/* eyelets */}
        <circle cx="11" cy="10.5" r="1.8" fill="hsl(var(--accent))" stroke="currentColor" strokeWidth="1" />
        <circle cx="11" cy="16.5" r="1.8" fill="hsl(var(--accent))" stroke="currentColor" strokeWidth="1" />
      </svg>
      {withText && (
        <span className={`font-display font-extrabold tracking-tighter text-[1.35rem] leading-none ${textClass}`}>
          Patch<span className="text-primary">wire</span>
        </span>
      )}
    </div>
  );
}
